/**
 * Header - 搜索栏切换逻辑
 */
var HeaderSearch = {
  isOpen: false,

  toggle: function () {
    this.isOpen = !this.isOpen;
    var form = document.getElementById('searchForm');
    var logo = document.getElementById('headerLogo');
    var btnSearch = document.getElementById('btnSearch');
    var btnCart = document.getElementById('btnCart');
    var btnMobile = document.getElementById('btnMobileMenu');
    var desktopNav = document.getElementById('desktopNav');

    if (this.isOpen) {
      if (form) form.classList.remove('hidden');
      if (logo) logo.classList.add('hidden');
      if (btnSearch) btnSearch.classList.add('hidden');
      if (btnCart) btnCart.classList.add('hidden');
      if (btnMobile) btnMobile.classList.add('hidden');
      if (desktopNav) desktopNav.classList.add('hidden');
      // Focus the input
      setTimeout(function () {
        var input = document.getElementById('searchInput');
        if (input) input.focus();
      }, 100);
    } else {
      if (form) form.classList.add('hidden');
      if (logo) logo.classList.remove('hidden');
      if (btnSearch) btnSearch.classList.remove('hidden');
      if (btnCart) btnCart.classList.remove('hidden');
      if (btnMobile) btnMobile.classList.remove('hidden');
      if (desktopNav) desktopNav.classList.remove('hidden');
    }
  },

  submit: function (e) {
    e.preventDefault();
    var input = document.getElementById('searchInput');
    if (input && input.value.trim()) {
      console.log('Searching for:', input.value);
      // In a real app, redirect to search results
    }
    this.toggle();
    return false;
  }
};

/**
 * MobileMenu - 移动端分类菜单
 */
var MobileMenu = {
  open: function () {
    var menu = document.getElementById('mobileMenu');
    if (menu) menu.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  },

  close: function () {
    var menu = document.getElementById('mobileMenu');
    if (menu) menu.classList.add('hidden');
    document.body.style.overflow = '';
  },

  toggleCategory: function (btn) {
    var chevron = btn.querySelector('.mobile-chevron');
    var submenu = btn.nextElementSibling;

    if (chevron) chevron.classList.toggle('open');
    if (submenu) submenu.classList.toggle('hidden');

    // Close other submenus
    var allBtns = document.querySelectorAll('#mobileMenuItems button');
    allBtns.forEach(function (b) {
      if (b !== btn) {
        var c = b.querySelector('.mobile-chevron');
        var s = b.nextElementSibling;
        if (c) c.classList.remove('open');
        if (s && s.classList && s.classList.contains('mobile-submenu')) {
          s.classList.add('hidden');
        }
      }
    });
  }
};
